// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoriesStyles } from "@tps/Overrides/Widgets/BrandDetails/BrandDetailsCategories";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

categoriesStyles.title = {
    variant: "h2",
    css: css`
        margin-bottom: 24px;
    `,
};

categoriesStyles.container = {
    css: css`
        border-top: 1px solid ${color("common.border")};
        padding-top: 32px;
    `,
};

categoriesStyles.categoryContainer = {
    gap: 22,
};

categoriesStyles.categoryItemRow = {
    width: [6, 3, 3, 3, 2.4] as any,
    css: css`
        margin-right: 20px;
        margin-bottom: 24px;
        display: flex;
        flex-direction: column;
        align-items: start;
    `,
};

categoriesStyles.innerCategoryContainer = {
    css: css`
        margin-bottom: 12px;
        max-width: 100%;
        height: 176px;
    `,
};

categoriesStyles.categoryImage = {
    width: "176px",
    height: "176px",
    css: css`
        img {
            height: auto;
        }
    `,
};

categoriesStyles.categoryNameLink = {
    color: "text.main",
    typographyProps: {
        weight: "bold",
        size: 16,
        css: css`
            overflow-wrap: break-word;
            word-wrap: break-word;
            line-height: 17px;
            text-align: center;
            width: 100%;
        `,
    },
    css: css`
        width: 100%;
        max-width: 176px;
    `,
};

categoriesStyles.subCategoryLink = {
    typographyProps: {
        size: 14,
        weight: "normal",
        css: css`
            overflow-wrap: break-word;
            word-wrap: break-word;
            line-height: 18px;
            max-width: 162px;
        `,
    },
    css: css`
        align-self: flex-start;
        margin-top: 10px;
    `,
};

categoriesStyles.viewMoreLink = {
    typographyProps: {
        size: 12,
        css: css`
            overflow-wrap: break-word;
            word-wrap: break-word;
            line-height: 18px;
        `,
    },
    css: css`
        align-self: flex-start;
        margin-top: 15px;
    `,
};
